import { ButtonGroup } from '@mui/material'
import React, { useMemo } from 'react'
import { Dish, DishWhite } from 'assets/images'
import Button from 'components/Button/Index'
import { useSelector } from 'react-redux'
import { tabData } from 'features/tab/tab'
import { menuList } from 'features/menu/menu'
import { paymentEnableData } from 'features/restaurant/restaurant'
import { ITab } from 'interfaces/tab'
import { getViewTabRoute, isOrderingEnabledAndHealthy } from 'utility/helper'

interface props {
  viewMenu?: boolean
  yourTab?: boolean
  orderMenu?: boolean
}

function MenuTab({ viewMenu, yourTab, orderMenu }: props) {
  const tab: ITab = useSelector(tabData)
  const menus = useSelector(menuList)
  const paymentEnable = useSelector(paymentEnableData)

  // Check if menus are available
  const hasMenus = menus && menus.length > 0

  // Check if ordering is enabled AND table health is good
  const isOrderingEnabled = isOrderingEnabledAndHealthy(menus, paymentEnable)

  // Determine the correct route for "View Tab" button using smart routing logic
  const tabRoute = useMemo(() => {
    return getViewTabRoute()
  }, [])

  return (
    <>
      <ButtonGroup
        variant="contained"
        className={`main-tab ${viewMenu || yourTab ? 'active' : ''} ${
          hasMenus ? 'dual-button' : 'single-button'
        }`}
      >
        {/* Only show Order Now/View Menu button if menus are available */}
        {hasMenus && (
          <Button
            variant="contained"
            color="secondary"
            isTypeLink
            title={isOrderingEnabled ? 'Order Now' : 'View Menu'}
            to={isOrderingEnabled ? '/order-menu' : '/view-menu'}
            linkState={{ establishmentId: tab.establishmentId }}
            className={viewMenu || orderMenu ? 'active' : ''}
          >
            <img src={DishWhite} alt="Order" className="active" />
            <img src={Dish} alt="Order" className="default" />
            <span>{isOrderingEnabled ? 'Order Now' : 'View Menu'}</span>
          </Button>
        )}
        <Button
          variant="contained"
          color="secondary"
          isTypeLink
          title="View Tab"
          to={tabRoute}
          linkState={{
            establishmentId: tab.establishmentId,
            isFromSplit: true,
          }}
          className={yourTab ? 'active' : ''}
        >
          <img src={DishWhite} alt="Dish" className="active" />
          <img src={Dish} alt="Dish" className="default" />
          <span>View Tab</span>
        </Button>
      </ButtonGroup>
    </>
  )
}

export default MenuTab
